<template>
    <div class="row flex-grow-1">
        <confirm-box ref="error" :no-confirm="true"></confirm-box>
        <h5 v-if="id" class="h5 text-primary">Editing User</h5>
        <h5 v-else class="h5 text-primary">Create User</h5>
        <div class="col-md-6 mb-2 mb-md-0">
            <input type="text" class="form-control" placeholder="Name" aria-label="Name" aria-describedby="basic-addon2" v-model="name"/>
        </div>
        
        <div class="col-md-6 mb-2 mb-2">
            <div class="input-group">
                <span class="input-group-text" id="basic-addon1">@</span>
                <input type="email" class="form-control" placeholder="Email Address" aria-label="EmailAddress" aria-describedby="basic-addon1" v-model="email"/>
            </div>
        </div>

        <div class="col-12 mb-2">
            <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" id="global-admin" v-model="isSuperAdmin">
                <label class="form-check-label" for="global-admin">Global Admin</label>
            </div>

            <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" id="global-admin" v-model="isContentAdmin" :disabled="isSuperAdmin">
                <label class="form-check-label" for="global-admin">Content Admin</label>
            </div>
        </div>

        <div class="col-4">
            <multiselect 
                v-model="allowed_districts" 
                :options="allDistricts"
                :multiple="true"
                :close-on-select="true"
                :searchable="true"
                placeholder="Districts"
                label="name"
                track-by="id"
            ></multiselect>
        </div>

        <cancel-submit-button
            @cancel="cancel()"
            @submit="submit()"
        ></cancel-submit-button>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import ConfirmBox from './ConfirmBox';
import CancelSubmitButton from './CancelSubmitButton.vue';

export default {
    name: 'UserForm',

    components: { Multiselect, ConfirmBox, CancelSubmitButton },

    props: {
        value: {
            type: Object,
            default: function(data={}) {
                return {};
            },
        },

        allDistricts: {
            type: Array,
            default: function() {
                return [];
            }
        }
    },

    data() {
        return {
            id: this.value.id ?? null,
            email: this.value.email ?? '',
            name: this.value.name ?? '',
            status: this.value.status ?? 1,
            districts: this.value.districts ?? [],
            allowed_districts: this.value.districts,
        }
    },

    computed: {
        isSuperAdmin: {
            get() {
                return this.status == 5;
            },

            set(status) {
                this.status = Boolean(status) ? 5 : 1;
            }
        },

        isContentAdmin: {
            get() {
                return this.status == 4;
            },

            set(status) {
                this.status = Boolean(status) ? 4 : 1;
            }
        },
    },

    methods: {
        submit() {
            this.$parent.isLoading = true;
            
            const data = {
                email: this.email,
                name: this.name,
                status: this.status,
                districts: this.allowed_districts,
            };

            if (this.id) {
                axios
                    .patch(`/api/admin/users/update/${this.id}`, data)
                    .then(response => {
                        console.log(response.data);
                        this.$emit('input', response.data);
                    })
                    .catch(error => {
                        if (error.response.status == 422) {
                            this.$refs.error.show({
                                title: 'User Update Error',
                                content: error.response.data.message,
                                callback: () => {},
                            });
                        } else {
                            console.error(error);
                            console.error(error.response);
                        }
                    })
                    .finally(() => {
                        this.$parent.isLoading = false;
                    });
            } else {
                axios
                    .post('/api/admin/users', data)
                    .then(response => {
                        this.$emit('input', response.data);
                    })
                    .catch(error => {
                        if (error.response.status == 422) {
                            this.$refs.error.show({
                                title: 'User Update Error',
                                content: error.response.data.message,
                                callback: () => {},
                            });
                        } else {
                            console.error(error);
                            console.error(error.response);
                        }
                    })
                    .finally(() => {
                        this.$parent.isLoading = false;
                    });       
            }
        },

        cancel() {
            this.$emit('cancel', this.id);
        },

        clear: function() {
            if (!this.id) {
                this.email = '';
                this.name = '';
                this.status = 1;
                this.allowed_districts = [];
            }
        }
    },

    updated() {
        if (this.isSuperAdmin) {
            this.status = 5;
        } else if (this.isContentAdmin) {
            this.status = 4;
        } else {
            this.status = 1;
        }
    }
}

</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
